module.exports = "##### Teal\n"